import { useContext } from "react";
import { identityContext } from "../contexts/IdentityContext";

export const useIdentity = () => {
  const { isAdmin, isFromExtension, isLoading } = useContext(identityContext);
  return { isAdmin, isFromExtension, isLoading };
};
